import React, { useEffect } from 'react';
import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let organizationProfilePageMachine: any;

export const useSMOrganizationProfilePage = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  organizationProfilePageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(organizationProfilePageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    organizationProfilePageMachine,
    organizationProfilePageState: state,
    organizationProfilePageSend: send,
  };
};
